import React from 'react';
import { motion } from 'framer-motion';

interface FooterProps {
  onTermsClick: () => void;
  onPrivacyClick: () => void;
}

export const Footer: React.FC<FooterProps> = ({ onTermsClick, onPrivacyClick }) => {
  return (
    <footer className="relative z-10 py-8 mt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8">
            {/* Logo */}
            <div className="flex items-center space-x-2">
              <img src="/logo.svg" alt="Quellect" className="w-6 h-6" />
              <span className="text-white font-semibold">Quellect</span>
            </div>
            
            {/* Divider */}
            <div className="hidden sm:block w-px h-6 bg-white/20"></div>
            
            {/* Links */}
            <div className="flex items-center space-x-6">
              <button
                onClick={onTermsClick}
                className="text-white/70 hover:text-white transition-colors text-sm"
              >
                Terms & Conditions
              </button>
              
              <button
                onClick={onPrivacyClick}
                className="text-white/70 hover:text-white transition-colors text-sm"
              >
                Privacy Policy
              </button>
              
              <a
                href="mailto:info@quellect.ai"
                className="text-white/70 hover:text-white transition-colors text-sm"
              >
                info@quellect.ai
              </a>
            </div>
          </div>
          
          {/* Copyright */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mt-6 text-white/50 text-sm"
          >
            © 2025 Quellect. All rights reserved.
          </motion.p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
